module.exports = __webpack_public_path__ + "static/media/feature-2.a3b6122e.png";